import * as Types from '../../../gql/base-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

// =============================================================================
// Auto-generated by GraphQL Codegen - DO NOT EDIT
// Change the .gql source (or the schema) and re-run: pnpm codegen
// =============================================================================

const defaultOptions = {} as const;
export type ServiceRunDetailFieldsFragment = { __typename?: 'mobility_runs', id: number, customer_id: number, status: string, product_type: string, departure_time?: string | null, dispatched_at?: string | null, departed_at?: string | null, completed_at?: string | null, created_at: string, estimated_distance_miles?: number | null, estimated_duration_minutes?: number | null, total_drive_time_seconds?: number | null, total_dwell_time_seconds?: number | null, config: object, profile_id?: number | null, profile?: { __typename?: 'workflowsets', id: number, name: string, mobile_inspection_workflow_id?: number | null, mobileInspectionWorkflow?: { __typename?: 'workflows', id: number, name: string, type: string, steps: object } | null } | null, driver?: { __typename?: 'drivers', id: number, status: string, user?: { __typename?: 'users', id: number, display_name: string, avatar_url?: string | null, phone?: string | null, email?: string | null } | null } | null, vehicle?: { __typename?: 'mobility_vehicles', id: number, make: string, model: string, year?: number | null, color?: string | null, license_plate?: string | null, vin?: string | null } | null, scenario?: { __typename?: 'scenarios', id: number, bundletoscenarios: Array<{ __typename?: 'bundletoscenarios', bundle: { __typename?: 'bundles', id: number, status: string, config: object, offers: Array<{ __typename?: 'offers', id: number, status: string, offered_at?: string | null, offered_by?: string | null, accepted_at?: string | null, accepted_by?: string | null, createdat: string, createdby: string, updatedat: string, updatedby: string, driver: { __typename?: 'drivers', id: number, status: string, user?: { __typename?: 'users', id: number, display_name: string, avatar_url?: string | null, phone?: string | null, email?: string | null } | null } }> } }> } | null, stops: Array<{ __typename?: 'mobility_stops', id: number, stop_order: number, status: string, address?: string | null, address_lat?: number | null, address_lng?: number | null, notes?: string | null, geofence_arrived_at?: string | null, geofence_departed_at?: string | null, driver_confirmed_at?: string | null, drive_time_seconds?: number | null, dwell_time_seconds?: number | null, location?: { __typename?: 'locations', id: number, name?: string | null, address?: string | null, latitude?: number | null, longitude?: number | null, geofence_radius?: number | null, geofence_vertices?: object | null, geofence_center_lat?: number | null, geofence_center_lng?: number | null } | null, service_stop_detail: Array<{ __typename?: 'service_stop_details', customer_name?: string | null, customer_phone?: string | null, service_description?: string | null, parking_location?: string | null, gate_code?: string | null, key_handoff_method?: string | null, special_instructions?: string | null, service_window?: string | null, estimated_service_minutes?: number | null, ro_reference?: string | null, is_fleet_stop: boolean, fleet_vehicle_count?: number | null, service_started_at?: string | null, service_completed_at?: string | null, skip_reason_code?: string | null, skip_notes?: string | null, hash_expires_at?: string | null }>, service_orders: Array<{ __typename?: 'service_orders', id: number, vehicle_vin?: string | null, vehicle_make?: string | null, vehicle_model?: string | null, vehicle_year?: number | null, vehicle_color?: string | null, service_description: string, estimated_minutes?: number | null, status: string, started_at?: string | null, completed_at?: string | null, workflow_data: object, vehiclephotos: Array<{ __typename?: 'vehiclephotos', id: string, url?: string | null, name: string, step_id: string, status: string, createdat: string, workflow_id: number }> }> }> };

export type GetServiceRunDetailSubscriptionVariables = Types.Exact<{
  runId: Types.Scalars['bigint']['input'];
}>;


export type GetServiceRunDetailSubscription = { __typename?: 'subscription_root', mobility_runs_by_pk?: { __typename?: 'mobility_runs', id: number, customer_id: number, status: string, product_type: string, departure_time?: string | null, dispatched_at?: string | null, departed_at?: string | null, completed_at?: string | null, created_at: string, estimated_distance_miles?: number | null, estimated_duration_minutes?: number | null, total_drive_time_seconds?: number | null, total_dwell_time_seconds?: number | null, config: object, profile_id?: number | null, profile?: { __typename?: 'workflowsets', id: number, name: string, mobile_inspection_workflow_id?: number | null, mobileInspectionWorkflow?: { __typename?: 'workflows', id: number, name: string, type: string, steps: object } | null } | null, driver?: { __typename?: 'drivers', id: number, status: string, user?: { __typename?: 'users', id: number, display_name: string, avatar_url?: string | null, phone?: string | null, email?: string | null } | null } | null, vehicle?: { __typename?: 'mobility_vehicles', id: number, make: string, model: string, year?: number | null, color?: string | null, license_plate?: string | null, vin?: string | null } | null, scenario?: { __typename?: 'scenarios', id: number, bundletoscenarios: Array<{ __typename?: 'bundletoscenarios', bundle: { __typename?: 'bundles', id: number, status: string, config: object, offers: Array<{ __typename?: 'offers', id: number, status: string, offered_at?: string | null, offered_by?: string | null, accepted_at?: string | null, accepted_by?: string | null, createdat: string, createdby: string, updatedat: string, updatedby: string, driver: { __typename?: 'drivers', id: number, status: string, user?: { __typename?: 'users', id: number, display_name: string, avatar_url?: string | null, phone?: string | null, email?: string | null } | null } }> } }> } | null, stops: Array<{ __typename?: 'mobility_stops', id: number, stop_order: number, status: string, address?: string | null, address_lat?: number | null, address_lng?: number | null, notes?: string | null, geofence_arrived_at?: string | null, geofence_departed_at?: string | null, driver_confirmed_at?: string | null, drive_time_seconds?: number | null, dwell_time_seconds?: number | null, location?: { __typename?: 'locations', id: number, name?: string | null, address?: string | null, latitude?: number | null, longitude?: number | null, geofence_radius?: number | null, geofence_vertices?: object | null, geofence_center_lat?: number | null, geofence_center_lng?: number | null } | null, service_stop_detail: Array<{ __typename?: 'service_stop_details', customer_name?: string | null, customer_phone?: string | null, service_description?: string | null, parking_location?: string | null, gate_code?: string | null, key_handoff_method?: string | null, special_instructions?: string | null, service_window?: string | null, estimated_service_minutes?: number | null, ro_reference?: string | null, is_fleet_stop: boolean, fleet_vehicle_count?: number | null, service_started_at?: string | null, service_completed_at?: string | null, skip_reason_code?: string | null, skip_notes?: string | null, hash_expires_at?: string | null }>, service_orders: Array<{ __typename?: 'service_orders', id: number, vehicle_vin?: string | null, vehicle_make?: string | null, vehicle_model?: string | null, vehicle_year?: number | null, vehicle_color?: string | null, service_description: string, estimated_minutes?: number | null, status: string, started_at?: string | null, completed_at?: string | null, workflow_data: object, vehiclephotos: Array<{ __typename?: 'vehiclephotos', id: string, url?: string | null, name: string, step_id: string, status: string, createdat: string, workflow_id: number }> }> }> } | null };

export const ServiceRunDetailFieldsFragmentDoc = gql`
    fragment ServiceRunDetailFields on mobility_runs {
  id
  customer_id
  status
  product_type
  departure_time
  dispatched_at
  departed_at
  completed_at
  created_at
  estimated_distance_miles
  estimated_duration_minutes
  total_drive_time_seconds
  total_dwell_time_seconds
  config
  profile_id
  profile {
    id
    name
    mobile_inspection_workflow_id
    mobileInspectionWorkflow {
      id
      name
      type
      steps
    }
  }
  driver {
    id
    status
    user {
      id
      display_name
      avatar_url
      phone
      email
    }
  }
  vehicle {
    id
    make
    model
    year
    color
    license_plate
    vin
  }
  scenario {
    id
    bundletoscenarios(
      order_by: {bundle: {createdat: desc}}
      where: {bundle: {status: {_in: ["ready", "dispatching", "dispatched"]}}}
      limit: 1
    ) {
      bundle {
        id
        status
        config
        offers(
          where: {status: {_in: ["offered", "accepted", "assigned"]}}
          order_by: {createdat: desc}
        ) {
          id
          status
          offered_at
          offered_by
          accepted_at
          accepted_by
          createdat
          createdby
          updatedat
          updatedby
          driver {
            id
            status
            user {
              id
              display_name
              avatar_url
              phone
              email
            }
          }
        }
      }
    }
  }
  stops(order_by: {stop_order: asc}) {
    id
    stop_order
    status
    address
    address_lat
    address_lng
    notes
    geofence_arrived_at
    geofence_departed_at
    driver_confirmed_at
    drive_time_seconds
    dwell_time_seconds
    location {
      id
      name
      address
      latitude
      longitude
      geofence_radius
      geofence_vertices
      geofence_center_lat
      geofence_center_lng
    }
    service_stop_detail {
      customer_name
      customer_phone
      service_description
      parking_location
      gate_code
      key_handoff_method
      special_instructions
      service_window
      estimated_service_minutes
      ro_reference
      is_fleet_stop
      fleet_vehicle_count
      service_started_at
      service_completed_at
      skip_reason_code
      skip_notes
      hash_expires_at
    }
    service_orders(order_by: {id: asc}) {
      id
      vehicle_vin
      vehicle_make
      vehicle_model
      vehicle_year
      vehicle_color
      service_description
      estimated_minutes
      status
      started_at
      completed_at
      workflow_data
      vehiclephotos(order_by: {createdat: asc}) {
        id
        url
        name
        step_id
        status
        createdat
        workflow_id
      }
    }
  }
}
    `;
export const GetServiceRunDetailDocument = gql`
    subscription getServiceRunDetail($runId: bigint!) {
  mobility_runs_by_pk(id: $runId) {
    ...ServiceRunDetailFields
  }
}
    ${ServiceRunDetailFieldsFragmentDoc}`;

/**
 * __useGetServiceRunDetailSubscription__
 *
 * To run a query within a React component, call `useGetServiceRunDetailSubscription` and pass it any options that fit your needs.
 * When your component renders, `useGetServiceRunDetailSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetServiceRunDetailSubscription({
 *   variables: {
 *      runId: // value for 'runId'
 *   },
 * });
 */
export function useGetServiceRunDetailSubscription(baseOptions: Apollo.SubscriptionHookOptions<GetServiceRunDetailSubscription, GetServiceRunDetailSubscriptionVariables> & ({ variables: GetServiceRunDetailSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<GetServiceRunDetailSubscription, GetServiceRunDetailSubscriptionVariables>(GetServiceRunDetailDocument, options);
      }
export type GetServiceRunDetailSubscriptionHookResult = ReturnType<typeof useGetServiceRunDetailSubscription>;
export type GetServiceRunDetailSubscriptionResult = Apollo.SubscriptionResult<GetServiceRunDetailSubscription>;